import config from '../config';

class SystemApi {
    private baseUrl: string;

    constructor() {
        this.baseUrl = config.API_URL;
    }

    private getHeaders(userId?: number, userTypeId?: number): HeadersInit {
        const headers: HeadersInit = {
            'Content-Type': 'application/json',
        };
        if (userId) headers['X-User-Id'] = userId.toString();
        if (userTypeId) headers['X-User-Type-Id'] = userTypeId.toString();
        return headers;
    }

    async checkQuoteMismatchExists(userId?: number, userTypeId?: number): Promise<boolean> {
        try {
            const response = await fetch(`${this.baseUrl}/api/system/quote-mismatch-exists`, {
                method: 'GET',
                headers: this.getHeaders(userId, userTypeId),
            });

            if (!response.ok) {
                if (response.status === 403) {
                    return false; // User not authorized - don't throw
                }
                throw new Error('Failed to check mismatch status');
            }

            const data = await response.json();
            return data.hasMismatch === true;
        } catch (error) {
            console.error('Error checking quote mismatch:', error);
            return false; // Fail silently
        }
    }

    async getDiscountBanner(): Promise<{ DiscountCodeId: number; DiscountHeader: string; DiscountDescripton: string } | null> {
        try {
            const response = await fetch(`${this.baseUrl}/api/system/discount-banner`, {
                method: 'GET',
                headers: this.getHeaders(),
            });

            if (!response.ok) {
                throw new Error('Failed to fetch discount banner');
            }

            const data = await response.json();
            return data.banner || null;
        } catch (error) {
            console.error('Error fetching discount banner:', error);
            return null; // Fail silently
        }
    }
}

export const systemApi = new SystemApi();
export default systemApi;
